<template>
    <ticto-loading v-if="loading" />
    <div class="my-5">
        <div style="display: flex">
            <ArchiveBoxIcon class="mr-2 h-8 w-7 shrink-0 text-gray-400" />
            <h3 class="mb-5 text-lg font-medium leading-9 dark:text-white">
                Release Notes
            </h3>
        </div>
        <div class="flex justify-end p-4">
            <button
                @click="openModal()"
                :disabled="loading"
                type="button"
                :class="{ 'cursor-not-allowed': loading }"
                class="ml-2 inline-flex items-center justify-center rounded-md bg-indigo-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
            >
                <PlusIcon class="mr-2 h-8 w-7 shrink-0 text-gray-400" />
                Nova Release
            </button>
            <button
                @click="openDrawer"
                class="ml-2 inline-flex items-center justify-center rounded-md bg-sky-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
            >
                <FunnelIcon class="mr-2 h-5 w-5" aria-hidden="true" />

                Filtros
            </button>
        </div>

        <transition name="slide">
            <div
                v-if="isDrawerOpen"
                class="fixed inset-0 z-50 flex justify-end overflow-y-auto"
            >
                <div
                    class="fixed inset-0 bg-black opacity-50"
                    @click="closeDrawer"
                ></div>
                <div
                    class="relative flex h-full min-h-screen w-80 flex-col bg-gray-800 text-white shadow-xl"
                >
                    <div class="flex h-full flex-col">
                        <div
                            class="flex items-center justify-between border-b p-4"
                        >
                            <h1
                                class="mb-2 border-b border-slate-500 pb-1 text-lg font-bold"
                            >
                                Filtros
                            </h1>

                            <button
                                @click="closeDrawer"
                                class="text-gray-600 hover:text-gray-800"
                            >
                                &times;
                            </button>
                        </div>
                        <div class="flex-1 p-4">
                            <form
                                @submit.prevent="handleFetch"
                                class="flex flex-col space-y-4"
                            >
                                <span class="w-full max-w-md">
                                    Produtos
                                    <input
                                        v-model="filters.products"
                                        type="text"
                                        id="products"
                                        class="text-input"
                                        :class="{
                                            'w-5/6': idFilter,
                                        }"
                                    />
                                </span>
                                <span class="w-full max-w-md">
                                    Data da Liberação
                                    <input
                                        v-model="filters.release_date"
                                        type="date"
                                        id="release_date"
                                        class="text-input"
                                        :class="{
                                            'w-5/6': idFilter,
                                        }"
                                    />
                                </span>

                                <span class="w-full max-w-md">
                                    Versão
                                    <input
                                        v-model="filters.version"
                                        type="text"
                                        id="version"
                                        class="text-input"
                                        :class="{
                                            'w-5/6': idFilter,
                                        }"
                                    />
                                </span>

                                <div class="flex space-x-2">
                                    <submit-button :loading="loading">
                                        Filtrar
                                    </submit-button>
                                    <button
                                        @click.prevent="clearFilters"
                                        :disabled="loading"
                                        type="button"
                                        :class="{
                                            'cursor-not-allowed': loading,
                                        }"
                                        class="btn-outline-primary px-4 py-1"
                                    >
                                        Limpar filtros
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="mt-10">
            <table class="w-full table-auto border-collapse text-sm">
                <thead class="bg-white dark:bg-slate-800">
                    <tr>
                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Produto (s)
                        </th>
                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Data da Liberação
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Versão
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Pré-requisitos
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Resumo
                        </th>

                        <th
                            scope="col"
                            class="p-3 text-left dark:text-slate-200"
                        >
                            Ações
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-slate-800">
                    <tr v-for="release in releases">
                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.products }}
                        </td>
                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ formatDate(release?.release_date) }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.version }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            {{ release?.prerequisites }}
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            <ul class="list-disc pl-5">
                                <li
                                    v-for="(item, index) in release?.descriptions"
                                    :key="index"
                                >
                                    {{ item.text }}
                                </li>
                            </ul>
                        </td>

                        <td
                            class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                        >
                            <button
                                @click="redirectDetails(release)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-sky-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                            >
                                <DocumentTextIcon
                                    class="text-black-400 mr-2 h-8 w-7 shrink-0"
                                />
                                Detalhes
                            </button>
                        </td>

                        <!-- <td>
                            <button
                                @click="openModal(release)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-indigo-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                            >
                                <PrinterIcon
                                    class="text-black-400 mr-2 h-8 w-7 shrink-0"
                                />
                                PDF
                            </button>
                        </td> -->

                        <td>
                            <button
                                @click="openModal(release)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-yellow-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                            >
                                <PencilIcon
                                    class="text-black-400 mr-2 h-8 w-7 shrink-0"
                                />
                                Editar
                            </button>
                        </td>
                        <td>
                            <button
                                @click.prevent="destroy(release.id)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="ml-2 inline-flex items-center justify-center rounded-md bg-red-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-red-400"
                            >
                                <TrashIcon
                                    class="text-black-400 mr-2 h-8 w-7 shrink-0"
                                />
                                Excluir
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <modal size="4xl" :open="modal" @close="modal = false">
        <div
            class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-white"
        ></div>
        <h1
            class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-white"
        >
            Release
        </h1>

        <form @submit.prevent="submitForm">
            <div class="mt-5 flex-col sm:mt-4 sm:flex">
                <div class="mb-3 grid gap-2 sm:grid-cols-2">
                    <div>
                        <label class="text-white"> Produto (s) </label>
                        <input
                            type="text"
                            id="products"
                            v-model="form.products"
                            name="products"
                            class="text-input"
                            placeholder="Ex: App/Mozart"
                            required
                        />
                    </div>

                    <div>
                        <label class="text-white"> Data da Liberação </label>
                        <input
                            type="date"
                            id="release_date"
                            v-model="form.release_date"
                            name="release_date"
                            class="text-input"
                            required
                        />
                    </div>
                </div>

                <div class="mb-3 grid gap-2 sm:grid-cols-2">
                    <div>
                        <label class="text-white"> Versão </label>
                        <input
                            v-model="form.version"
                            type="text"
                            id="version"
                            name="version"
                            class="text-input"
                            placeholder="Ex: 31.0"
                            required
                        />
                    </div>

                    <div>
                        <label class="text-white"> Pré Requisitos </label>
                        <input
                            v-model="form.prerequisites"
                            type="text"
                            id="prerequisites"
                            name="prerequisites"
                            class="text-input"
                            placeholder="Ex: Testes em QA"
                            required
                        />
                    </div>
                </div>
            </div>
            <div class="mt-4 flex justify-center">
                <submit-button :loading="loading" :disabled="loading">
                    Salvar
                </submit-button>
            </div>
        </form>
    </modal>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
ArchiveBoxIcon,
CheckCircleIcon,
DevicePhoneMobileIcon,
DocumentIcon,
DocumentTextIcon,
FunnelIcon,
LinkIcon,
PencilIcon,
PlusCircleIcon,
PlusIcon,
PrinterIcon,
StopCircleIcon,
TrashIcon,
VideoCameraIcon,
} from "@heroicons/vue/24/outline";
import { useToast } from "vue-toastification";
import SubmitButton from "../../components/forms/SubmitButton.vue";
import UsersSelect from "../../components/forms/UsersSelect.vue";
import VueSelect from "../../components/forms/VueSelect.vue";
import EmptyState from "../../components/layouts/EmptyState.vue";
import Filters from "../../components/layouts/Filters.vue";
import Modal from "../../components/layouts/Modal.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import Manager from "../../components/manager/Manager.vue";
import StoreModal from "../../components/manager/modals/StoreModal.vue";

export default {
    components: {
        EmptyState,
        StoreModal,
        Manager,
        VueSelect,
        UsersSelect,
        TictoLoading,
        DevicePhoneMobileIcon,
        CheckCircleIcon,
        VideoCameraIcon,
        PlusCircleIcon,
        PencilIcon,
        FontAwesomeIcon,
        StopCircleIcon,
        TrashIcon,
        Filters,
        Modal,
        SubmitButton,
        ArchiveBoxIcon,
        DocumentIcon,
        FunnelIcon,
        LinkIcon,
        PrinterIcon,
        PlusIcon,
        DocumentTextIcon,
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            isDrawerOpen: false,
            loading: false,
            modal: false,
            release: null,
            modalVideos: false,
            counter: 0,
            form: {
                id: null,
                products: null,
                release_date: null,
                version: null,
                prerequisites: null,
            },
            releases: [],
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
            filters: {
                products: "",
                release_date: "",
                version: "",
            },
            next_page_url: false,
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString("pt-BR");
        },
        clearFilters() {
            this.filters = {
                products: null,
                release_date: null,
                version: null,
            };

            this.fetch();
        },
        openDrawer() {
            this.isDrawerOpen = true;
        },
        closeDrawer() {
            this.isDrawerOpen = false;
        },
        handleFetch() {
            this.isDrawerOpen = false;
            this.fetch();
        },
        transformToFilterObject(obj) {
            const filterObject = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    filterObject[`filter[${key}]`] = obj[key];
                }
            }
            return filterObject;
        },
        fetch() {
            this.loading = true;
            const params = this.filters;

            axios
                .get("/api/releases", {
                    params: this.transformToFilterObject(params),
                })
                .then(({ data }) => {
                    this.releases = data.data;
                })
                .catch((error) => {
                    this.toast.error(
                        error.response?.data?.message ||
                            "Não foi possível carregar as releases.",
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        extractValidationMessage(error, fallback) {
            const errors = error.response?.data?.errors;
            if (errors && typeof errors === "object") {
                const first = Object.values(errors)[0];
                if (Array.isArray(first) && first.length) {
                    return first[0];
                }
                if (typeof first === "string") {
                    return first;
                }
            }
            return error.response?.data?.message || fallback;
        },
        openModal(release) {
            this.closeModal();
            if (release) {
                this.form.id = release.id;
                this.form.products = release.products;
                this.form.release_date = release.release_date.split(" ")[0];
                this.form.version = release.version;
                this.form.prerequisites = release.prerequisites;
            }
            this.modal = true;
        },
        redirectDetails(release) {
            this.$router.push({
                name: "release.details",
                params: { release_id: release.id },
            });
        },
        closeModal() {
            this.release = null;
            this.form.id = null;
            this.form.products = null;
            this.form.release_date = null;
            this.form.version = null;
            this.form.prerequisites = null;
            this.loading = false;
            this.modal = false;
        },

        destroy(id) {
            this.loading = true;
            axios
                .delete(`/api/releases/${id}`)
                .then(() => {
                    this.toast.success("Release deletada com sucesso!");
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    this.toast.error(
                        this.extractValidationMessage(
                            error,
                            "Ocorreu um erro, tente novamente!",
                        ),
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        submitForm() {
            this.loading = true;

            const request =
                this.form.id == null
                    ? axios.post(`/api/releases`, this.form)
                    : axios.put(`/api/releases/${this.form.id}`, this.form);

            const successMessage =
                this.form.id == null
                    ? "Release cadastrada com sucesso!"
                    : "Release alterada com sucesso!";

            request
                .then(() => {
                    this.toast.success(successMessage);
                    this.closeModal();
                    this.fetch();
                })
                .catch((error) => {
                    this.toast.error(
                        this.extractValidationMessage(
                            error,
                            "Ocorreu um erro, tente novamente!",
                        ),
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}
.slide-enter,
.slide-leave-to {
    transform: translateX(-100%);
}
</style>
